import { render } from "./newEnrolment.vue?vue&type=template&id=03783fb5&scoped=true"
import script from "./newEnrolment.vue?vue&type=script&lang=js"
export * from "./newEnrolment.vue?vue&type=script&lang=js"

import "./newEnrolment.vue?vue&type=style&index=0&id=03783fb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03783fb5"]])

export default __exports__